/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ e1rmText: NonNullable<unknown> }} Wrapped_Strength_GainInputs */

const en_us2_wrapped_strength_gain = /** @type {(inputs: Wrapped_Strength_GainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`An estimated max strength of ${i?.e1rmText}, your biggest jump of the week.`)
};

const pt_br2_wrapped_strength_gain = /** @type {(inputs: Wrapped_Strength_GainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Força máxima estimada de ${i?.e1rmText}, seu maior salto da semana.`)
};

const es_419_wrapped_strength_gain = /** @type {(inputs: Wrapped_Strength_GainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Una fuerza máxima estimada de ${i?.e1rmText}, tu mayor salto de la semana.`)
};

const pt_pt2_wrapped_strength_gain = /** @type {(inputs: Wrapped_Strength_GainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Força máxima estimada de ${i?.e1rmText}, o teu maior salto da semana.`)
};

const fr_fr2_wrapped_strength_gain = /** @type {(inputs: Wrapped_Strength_GainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Une force max estimée de ${i?.e1rmText}, ton plus gros bond de la semaine.`)
};

const de_de2_wrapped_strength_gain = /** @type {(inputs: Wrapped_Strength_GainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eine geschätzte Maximalkraft von ${i?.e1rmText}, dein größter Sprung der Woche.`)
};

const it_it2_wrapped_strength_gain = /** @type {(inputs: Wrapped_Strength_GainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Una forza massima stimata di ${i?.e1rmText}, il tuo salto più grande della settimana.`)
};

/**
* | output |
* | --- |
* | "An estimated max strength of {e1rmText}, your biggest jump of the week." |
*
* @param {Wrapped_Strength_GainInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_strength_gain = /** @type {((inputs: Wrapped_Strength_GainInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Strength_GainInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_strength_gain(inputs)
	if (locale === "es-419") return es_419_wrapped_strength_gain(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_strength_gain(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_strength_gain(inputs)
	if (locale === "de-DE") return de_de2_wrapped_strength_gain(inputs)
	if (locale === "it-IT") return it_it2_wrapped_strength_gain(inputs)
	return en_us2_wrapped_strength_gain(inputs)
});
export { wrapped_strength_gain as "wrapped.strength_gain" }